module.exports = __webpack_public_path__ + "static/join_honors_obj02@2x-27322b7c941258780d5a5a11e7d9ccc5.png";